(() => {
  if (customElements.get('mermacorn-builder')) return;
  class MermacornBuilder extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.labels = JSON.parse(this.querySelector('[data-translations]').textContent);
      this.bracelets = Array.from({ length: 4 }, () => ({ color: 0, beads: [] }));
      this.active = 0;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-bracelet')) this.select(Number(button.dataset.bracelet));
        if (button.hasAttribute('data-edit')) this.select(Number(button.dataset.edit), true);
        if (button.hasAttribute('data-previous')) this.select(this.active - 1, true);
        if (button.hasAttribute('data-next')) this.select(this.active + 1, true);
        if (button.hasAttribute('data-review')) this.querySelector('[data-summary-section]').focus();
      });
      this.addEventListener('change', event => {
        const input = event.target;
        const bracelet = this.bracelets[this.active];
        if (input.matches('[data-color]')) {
          bracelet.color = Number(input.value);
          this.render();
        }
        if (input.matches('[data-bead]')) {
          const id = Number(input.value);
          if (input.checked && !bracelet.beads.includes(id)) {
            if (bracelet.beads.length >= 3) {
              input.checked = false;
              this.querySelector('[data-feedback]').textContent = this.labels.max;
              return;
            }
            bracelet.beads.push(id);
          } else if (!input.checked) {
            bracelet.beads = bracelet.beads.filter(bead => bead !== id);
          }
          this.render();
        }
      });
      this.hidden = false;
      this.render();
    }
    label(key, number) { return this.labels[key].replace('__N__', String(number)); }
    select(index, focus = false) {
      if (!Number.isInteger(index) || index < 0 || index > 3) return;
      this.active = index;
      this.render();
      if (focus) this.querySelector('[data-active-title]').focus();
    }
    render() {
      const bracelet = this.bracelets[this.active];
      this.querySelectorAll('[data-bracelet]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.bracelet) === this.active)));
      this.querySelector('[data-active-title]').textContent = this.label('bracelet', this.active + 1);
      this.querySelector('[data-preview-index]').textContent = `0${this.active + 1} / 04`;
      this.querySelectorAll('[data-color]').forEach(input => { input.checked = Number(input.value) === bracelet.color; });
      this.querySelectorAll('[data-bead]').forEach(input => { input.checked = bracelet.beads.includes(Number(input.value)); });
      this.querySelector('[data-bead-count]').textContent = this.label('count', bracelet.beads.length);
      this.querySelector('[data-feedback]').textContent = '';
      this.querySelector('[data-previous]').disabled = this.active === 0;
      this.querySelector('[data-next]').hidden = this.active === 3;
      this.querySelector('[data-review]').hidden = this.active !== 3;
      const ring = this.querySelector('[data-ring]');
      ring.style.setProperty('--bead-color', this.labels.colorValues[bracelet.color]);
      this.querySelector('.mc-preview').setAttribute('aria-label', [this.label('bracelet', this.active + 1), this.labels.colors[bracelet.color], bracelet.beads.length ? bracelet.beads.map(id => this.labels.beads[id]).join(', ') : this.labels.none].join('. '));
      ring.replaceChildren();
      const glyphs = ['★', '♥', '◒', '☾'];
      for (let i = 0; i < 22; i++) {
        const bead = document.createElement('span');
        bead.style.setProperty('--i', i);
        const special = bracelet.beads[Math.floor(i / 2)];
        if (i % 2 === 0 && i < bracelet.beads.length * 2) {
          bead.className = 'mc-ring-special';
          bead.textContent = glyphs[special];
        }
        ring.append(bead);
      }
      const list = this.querySelector('[data-summary]');
      list.replaceChildren(...this.bracelets.map((item, i) => {
        const li = document.createElement('li');
        const heading = document.createElement('h3');
        heading.textContent = this.label('bracelet', i + 1);
        const color = document.createElement('p');
        color.textContent = this.labels.colors[item.color];
        const beads = document.createElement('p');
        beads.textContent = item.beads.length ? item.beads.map(id => this.labels.beads[id]).join(', ') : this.labels.none;
        const edit = document.createElement('button');
        edit.type = 'button';
        edit.dataset.edit = i;
        edit.textContent = this.label('edit', i + 1);
        li.append(heading, color, beads, edit);
        return li;
      }));
    }
  }
  customElements.define('mermacorn-builder', MermacornBuilder);
})();
